import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { API_ciudadanos, API_usuarios } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaAngleDown, FaAngleUp, FaCalendarDay, FaCalendarPlus, FaMessage, FaEye, FaEyeSlash } from "react-icons/fa6";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import Navbar from "../../components/Navbar";
import LoadingSpinner from "../../components/LoadingSpinner";
import NuevoMensaje from "../../components/dashboard_tecnico/NuevoMensaje";
import ModalAgendarCita from "../../components/dashboard_tecnico/ModalAgendarCita";
import Estados from "../../components/cv/Estados";
import Datos from "../../components/cv/Datos";
import Colectivos from "../../components/cv/Colectivos";
import Notas from "../../components/cv/Notas";
import Programas from "../../components/cv/Programas";
import Ocupaciones from "../../components/cv/Ocupaciones";
import Idiomas from "../../components/cv/Idiomas";
import Digital from "../../components/cv/Digital";
import Habilidades from "../../components/cv/Habilidades";
import SobreMi from "../../components/cv/SobreMi";
import Experiencia from "../../components/cv/Experiencia";
import Formacion from "../../components/cv/Formacion";
import Competencias from "../../components/cv/Competencias";
import Documentos from "../../components/cv/Documentos";
import Social from "../../components/cv/Social";
import Historial from "../../components/cv/HistorialSeguimiento";
import "./css/Expediente.css";
import { API_BASE_URL } from "../../config/apiConfig";
import { useAuth } from "../../context/AuthContext";
import { confirmToast } from "../../components/toast/confirmToast";

const Expediente = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  // Se crea un nuevo usuario y todavía no tiene id
  const esNuevoUsuario = id === "nuevo";
  const [isDownloadingCv, setIsDownloadingCv] = useState(false);

  const role = useSelector((state) => state.auth.role);

  // chek to render button delete
  const canDelete = useMemo(() => role === "administrador" && Boolean(id), [role, id]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeletingMModalOpen, setIsDeletingModalOpen] = useState(false);

  console.log(role, "role desde Expediente.js");
  const [usuario, setUsuario] = useState(
    esNuevoUsuario
      ? {
          name: "Nombre",
          lastName: "Apellido",
          email: "email",
          password: "",
          dni: "DNI",
          phone: "Telefono",
          address: "dirección",
          postalCode: "C.P.",
          city: "Ciudad",
          country: "País",
          estadoUsuario: "Activo",
        }
      : null
  );

  // Icono ojo que permite ver o no la contraseña de los nuevos usuarios
  const [verPassword, setVerPassword] = useState(false);
  // Próxima cita que viene de la app
  const [proximaCita, setProximaCita] = useState(null);
  // Descargar Expediente
  const [isDownloading, setIsDownloading] = useState(false);
  // Estado para controlar si existe un currículum en la carpeta curriculums
  const [tieneCurriculum, setTieneCurriculum] = useState(false);
  const [curriculumFile, setCurriculumFile] = useState(null);
  // Ventanas emergentes de los accesos directos para pedir cita y enviar mensaje
  const [agendarCita, setAgendarCita] = useState(false);
  const [mostrarMensaje, setMostrarMensaje] = useState(false);

  // Funcion para confirmar la eliminación del usuario
  async function handleUserDelete() {
    if (isDeletingMModalOpen) return;
    setIsDeletingModalOpen(true);
    const ok = await confirmToast({
      title: `¿Eliminar la cuenta de ${usuario?.name ?? usuario?.email}?`,
      message: `Esta acción es irreversible. Se borrarán perfil, sesiones, archivos y demás datos asociados. `,
      confirmText: "Eliminar cuenta",
      cancelText: "Cancelar",
    });

    if (!ok) return setIsDeletingModalOpen(false);

    try {
      setIsDeleting(true);
      // optionally show a "loading state" inside the toast

      const res = await fetch(`${API_BASE_URL}/auth/deleteCitizen`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": token, // si tu server lo permite
        },
        body: JSON.stringify({ userId: id }), // usa el id real
      });
      if (!res.ok) {
        throw new Error("Error al eliminar el usuario");
      }
      toast.success("Uauario eliminado Correctamente");
      navigate("/admin/usuarios");
    } catch (e) {
      toast.error("No se pudo eliminar el usuario intenta más tarde");
    } finally {
      setIsDeletingModalOpen(false);
      setIsDeleting(false);
    }
  }

  useEffect(() => {
    const obtenerCiudadano = async () => {
      try {
        const res = await fetch(`${API_ciudadanos}/${id}`, {
          headers: {
            Accept: "application/json",
            // 'x-auth-token': token, // if you use this, server must allow it
          },
        });

        const encontrado = await res.json();
        if (encontrado) {
          setUsuario(encontrado);

          const citasRes = await fetch(`${API_ciudadanos}/${encontrado.userId}/citas`);
          const citasData = await citasRes.json();
          const hoy = new Date();
          hoy.setHours(0, 0, 0, 0);

          const futuras = citasData
            .filter((c) => c.state?.toLowerCase() === "aceptado")
            .filter((c) => new Date(c.appointmentDate) >= hoy)
            .sort((a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate));

          if (futuras.length > 0) {
            setProximaCita(futuras[0]);
          }

          // Verificar si existe un currículum en la carpeta curriculums
          await verificarCurriculum(encontrado.userId);
        }
      } catch (error) {
        console.error("Error al obtener ciudadano:", error);
        toast.error("Error al cargar los datos del ciudadano");
      }
    };

    if (id) {
      obtenerCiudadano();
    }
  }, [id, token]);

  // Función para verificar si existe un currículum en la carpeta curriculums
  const verificarCurriculum = async (userId) => {
    try {
      const res = await fetch(`${API_ciudadanos}/${userId}/files`, {
        headers: { "x-auth-token": token },
      });
      const data = await res.json();

      if (Array.isArray(data)) {
        // Buscar archivos en la carpeta 'curriculums'
        const curriculumEncontrado = data.find((doc) => doc.folder === "cvplataforma");

        if (curriculumEncontrado) {
          setTieneCurriculum(true);
          setCurriculumFile({
            id: curriculumEncontrado.fileId,
            nombre: curriculumEncontrado.filename,
            url: `${API_BASE_URL}/downloads/ciudadanos/${curriculumEncontrado.fileId}`,
          });
        } else {
          setTieneCurriculum(false);
          setCurriculumFile(null);
        }
      }
    } catch (error) {
      console.error("Error al verificar currículum:", error);
      setTieneCurriculum(false);
      setCurriculumFile(null);
    }
  };

  // Fecha en formato DD/MM/AAA
  const formatearFechaCita = (isoDate) => {
    const fecha = new Date(isoDate);
    const opciones = { weekday: "long", day: "numeric", month: "long" };
    return fecha.toLocaleDateString("es-ES", opciones);
  };

  // Click que descarga Expediente
  const handleDownloadClick = () => {
    setIsDownloading(!isDownloading);
  };

  // Descargar currículum real del usuario
  const downloadCurriculumPDF = async () => {
    if (!usuario?.userId) return;

    setIsDownloadingCv(true);

    try {
      // 1️⃣ Fetch file list
      const res = await fetch(`${API_ciudadanos}/${encodeURIComponent(usuario.userId)}/files`, { headers: { "x-auth-token": token } });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Bad payload");

      // 2️⃣ Filter only CV files
      const cvFiles = data
        .filter((d) => d?.filename && d.filename.toLowerCase().startsWith("cv_"))
        .map((d) => ({
          id: d.fileId,
          nombre: d.filename,
          url: `${API_BASE_URL}/downloads/ciudadanos/${encodeURIComponent(d.fileId)}`,
          espacio: d.folder || "",
        }));

      if (cvFiles.length === 0) {
        toast.error("El usuario no tiene disponible su CV, inténtelo más tarde");
        return;
      }

      const selectedCv = cvFiles[0];

      // 3️⃣ Fetch CV file
      const response = await fetch(selectedCv.url, {
        headers: { "x-auth-token": token },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      // 4️⃣ Convert to blob and trigger download
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = selectedCv.nombre;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 5️⃣ Clean up
      setTimeout(() => URL.revokeObjectURL(objectUrl), 500);
    } catch (error) {
      console.error(error);
      toast.error("El usuario no tiene disponible su CV, inténtelo más tarde");
    } finally {
      setIsDownloadingCv(false);
    }
  };

  // Descargar Expediente en pdf
  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Información del Expediente", 10, 10);
    let y = 20;
    Object.entries(usuario).forEach(([key, val]) => {
      doc.text(`${key}: ${val}`, 10, y);
      y += 10;
    });
    doc.save("expediente.pdf");
  };

  // Descargar Expediente en csv
  const downloadCSV = () => {
    const data = Object.entries(usuario).map(([key, val]) => [key, val]);
    const worksheet = XLSX.utils.aoa_to_sheet([["Campo", "Valor"], ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Expediente");
    XLSX.writeFile(workbook, "expediente.xlsx");
  };

  // Guardar nuevo usuario en bbdd
  const handleGuardarNuevoUsuario = async () => {
    try {
      // TOOD: verificar que este caso de uso sea aplicable, API de ciudadanos no puede deja crear registros de forma trivial por restricciones de seguridad y usabilidad
      const resUsuario = await fetch(API_usuarios, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: usuario.name,
          lastName: usuario.lastName,
          email: usuario.email,
          password: usuario.password,
          role: "ciudadano",
        }),
      });

      if (!resUsuario.ok) throw new Error("Error al crear en API_usuarios");
      const userData = await resUsuario.json();

      const resCiudadano = await fetch(API_ciudadanos, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...usuario,
          userId: userData.id,
        }),
      });

      if (!resCiudadano.ok) throw new Error("Error al crear en API_ciudadanos");

      alert("Usuario creado correctamente");
      navigate(`/admin/expediente/${userData.id}`);
    } catch (err) {
      console.error(err);
      alert("Error al crear el usuario");
    }
  };

  const handleActivarUsuario = async () => {
    try {
      // Llamada a tu backend proxy en localhost:4000
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}/cambiarEstado`, {
        method: "PATCH", // coincide con Estados.js
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ estadoUsuario: "Activo" }),
      });
      if (!res.ok) throw new Error("Error al activar usuario");
      // Si todo ha ido bien, actualizamos localmente y mostramos notificación
      setUsuario((prev) => ({
        ...prev,
        estadoUsuario: "Activo",
      }));
      toast.success("Usuario activado correctamente");
    } catch (error) {
      console.error("❌ Error al activar usuario:", error);
      toast.error("Error al activar el usuario");
    }
  };

  // Callback para cuando se crea una nueva cita desde el modal
  const handleCitaCreada = (nuevaCita) => {
    // Actualizar la próxima cita si la nueva cita es futura
    if (nuevaCita.start) {
      const fechaCita = new Date(nuevaCita.start);
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      if (fechaCita >= hoy) {
        // Si no hay próxima cita o esta es más próxima, actualizarla
        if (!proximaCita || fechaCita < new Date(proximaCita.appointmentDate)) {
          setProximaCita({
            subject: nuevaCita.title,
            appointmentDate: nuevaCita.start.toISOString(),
          });
        }
      }
    }
  };

  return (
    <>
      <Navbar />
      <main className="main expediente">
        {!usuario ? (
          <LoadingSpinner message="Cargando información del usuario..." />
        ) : usuario.estadoUsuario === "Aceptado" && !esNuevoUsuario ? (
          <>
            {" "}
            {/* Aviso el usuario está aceptado pero no activo. No se puede ver la página sin activarlo */}
            <div className="aviso-usuario column mb-30">
              <p>
                <strong>Este usuario está aceptado pero todavía no ha sido activado.</strong>
                <br />
                Hasta que no se active no podrá completar su expediente.
              </p>
              <div className="text-left mt-10">
                <p>
                  <span className="bold">Nombre:</span> {usuario.name} {usuario.lastName}
                </p>
                <p>
                  <span className="bold">Teléfono:</span> {usuario.phone}
                </p>
                <p>
                  <span className="bold">Email:</span> {usuario.email}
                </p>
              </div>
              <button className="boton mt-20 bold" onClick={handleActivarUsuario}>
                Activar usuario
              </button>
            </div>
          </>
        ) : (
          <>
            {" "}
            {/* A partir de aquí lo que se ve del expediente, que ya está activado */}
            <section className="cabecera between">
              <div className="comunicaciones flex">
                {/* Próxima cita */}
                <div className="comunicacion__bloque-izquierdo flex">
                  <div className="proxima-cita align-center fondo-verde blanco">
                    <FaCalendarDay />
                    <p>
                      <strong>PRÓXIMA CITA:</strong>
                    </p>
                    {proximaCita ? <p>{formatearFechaCita(proximaCita.appointmentDate)}</p> : <p>No tiene citas próximamente.</p>}
                  </div>

                  {/* Botones agendar cita nueva o enviar nuevo mensaje */}
                  <div className="botones flex">
                    <button
                      className="align-center fondo-verde blanco"
                      aria-label="Agendar nueva cita aspect-square"
                      onClick={() => {
                        setAgendarCita(true);
                      }}
                    >
                      <FaCalendarPlus />
                    </button>
                    {/* <button
                      className="align-center fondo-verde blanco aspect-square"
                      aria-label="Enviar mensaje"
                      onClick={() => {
                        setMostrarMensaje(true);
                      }}
                    >
                      <FaMessage />
                    </button> */}
                  </div>

                  {/* Botón para guardar al usuario nuevo */}
                  {esNuevoUsuario && (
                    <button className="boton verde nuevo-usuario" onClick={handleGuardarNuevoUsuario}>
                      Guardar nuevo usuario
                    </button>
                  )}
                </div>
                <div className="comunicacion__bloque-derecho flex">
                  <button disabled={isDownloadingCv} className="boton verde nuevo-usuario" onClick={downloadCurriculumPDF}>
                    {isDownloadingCv ? "Descargando..." : "descargar PDF"}
                  </button>
                  {role === "administrador" && id && (
                    <button
                      className={`fondo-rojo blanco uppercase ${
                        isDeletingMModalOpen ? "opacity-25 cursor-not-allowed hover:cursor-not-allowed" : ""
                      }`}
                      onClick={() => handleUserDelete()}
                      disabled={isDeletingMModalOpen}
                    >
                      Eliminar usuario
                    </button>
                  )}
                  {/* <a
                    className="boton verde nuevo-usuario"
                    href="/plantilla/Plantilla-Europass.doc"
                    download
                  >
                    DESCARGAR PLANTILLA EUROPASS
                  </a> */}

                  {/* Botón descargar expediente con opciones Excel y pdf */}
                  {/* {tieneCurriculum && (
                    <div className="descargar-expediente">
                      <button
                        className={`descargar align-center mayusculas fondo-verde blanco ${isDownloading ? "no-radius" : ""}`}
                        onClick={handleDownloadClick}
                      >
                        {" "}
                        DESCARGAR CURRÍCULUM {isDownloading ? <FaAngleUp /> : <FaAngleDown />}
                      </button>
                      {isDownloading && (
                        <div className="opciones absolute column fondo-blanco">
                          <button className="fondo-blanco verde" onClick={downloadCurriculumPDF}>
                            Descargar PDF
                          </button>
                        </div>
                      )}
                    </div>
                  )} */}
                </div>
              </div>
            </section>
            {/* Ventana emergente Enviar nuevo mensaje */}
            {/* {mostrarMensaje && (
              <NuevoMensaje
                dni={usuario?.dni}
                onClose={() => setMostrarMensaje(false)}
                onEnviar={(mensaje) => {
                  setMostrarMensaje(false);
                }}
              />
            )} */}
            {/* Modal para agendar nueva cita */}
            <ModalAgendarCita
              isOpen={agendarCita}
              onClose={() => setAgendarCita(false)}
              onCitaCreada={handleCitaCreada}
              usuarioPorDefecto={usuario}
            />
            <section className="cv between">
              <div className="columna-izquierda column">
                <Estados rol={role} usuario={usuario} setUsuario={setUsuario} />

                {/* Crearle una contraseña a un nuevo usuario */}
                {esNuevoUsuario && (
                  <div className="formulario-password">
                    <label className="label-password align-center gap-5 verde bold">
                      Contraseña:
                      <div className="input-icono relative">
                        <input
                          type={verPassword ? "text" : "password"}
                          value={usuario.password}
                          onChange={(e) =>
                            setUsuario((prev) => ({
                              ...prev,
                              password: e.target.value,
                            }))
                          }
                          required
                        />
                        <button type="button" className="icono-ojo absolute fondo-blanco" onClick={() => setVerPassword(!verPassword)}>
                          {verPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                    </label>
                  </div>
                )}

                <Datos rol={role} usuario={usuario} setUsuario={setUsuario} />
                <Colectivos usuario={usuario} setUsuario={setUsuario} />
                <Notas usuario={usuario} setUsuario={setUsuario} />
                <Programas usuario={usuario} setUsuario={setUsuario} />
                <Ocupaciones usuario={usuario} setUsuario={setUsuario} />
                <Idiomas usuario={usuario} setUsuario={setUsuario} />
                <Digital usuario={usuario} setUsuario={setUsuario} />
                <Habilidades usuario={usuario} setUsuario={setUsuario} />
              </div>
              <div className="columna-derecha column">
                <SobreMi usuario={usuario} setUsuario={setUsuario} />
                <Experiencia usuario={usuario} setUsuario={setUsuario} />
                <Formacion usuario={usuario} setUsuario={setUsuario} />
                <Competencias usuario={usuario} setUsuario={setUsuario} />
                <Documentos usuario={usuario} setUsuario={setUsuario} />
                <Social usuario={usuario} setUsuario={setUsuario} />
              </div>
            </section>
            <Historial usuario={usuario} />
          </>
        )}
      </main>
    </>
  );
};

export default Expediente;
